import React from 'react';
import VolumeItemWrapper from 'views/LearningCommunity/VolumeList/style/VolumeItemWrapper';
import VolumeBox from 'views/LearningCommunity/VolumeList/VolumeBox';
import VolumeBoxWrapper from 'views/LearningCommunity/VolumeList/style/VolumeBoxWrapper';
import SortableChapterList from 'views/LearningCommunity/VolumeList/SortableChapterList';
import { volumesMockData } from 'mocks/mockRestData/volumesMockData';

const LCSidebarPreview = () => (
  <VolumeBoxWrapper className='m--0 p--0'>
    <VolumeItemWrapper className='open-volume volume-item d-flex align-items-center' data-testid='open-btn'>
      <VolumeBox
        volumeId={volumesMockData.id}
        name={volumesMockData.name}
        isOpen
        isLast
        setOpenKeys={() => {}}
        isPreview
      />
    </VolumeItemWrapper>
    <SortableChapterList volume={volumesMockData} onSortEnd={() => {}} pressDelay={200} useDragHandle isPreview />
  </VolumeBoxWrapper>
);

export default LCSidebarPreview;
